import React from "react";
import { OutlinedSvgText, numTicksForPixels } from "./utils";
export const XAxisTitle = ({ xScale, title, innerHeight }) => {
    const [, xMax] = xScale.range();
    return (
        <text
            x={xMax}
            y={innerHeight}
            textAnchor="end"
            dx={-315}
            dy={40}
            fill="var(--gray-600)"
            className="font-semibold text-2xs text-shadow-white-stroke"
        >
            {title}
        </text>
    )
}


/** X-axis with title and grid lines */

export const XAxis = ({ xScale, formatter, innerHeight, gridLineHeight }) => {
    const [xMin, xMax] = xScale.range();
    const ticks = xScale.ticks(numTicksForPixels(xMax - xMin));
    return (
        <g data-testid="XAxis" transform={`translate(0 ${innerHeight})`}>
            <line x1={xMin} x2={xMax} y1={0} y2={0} stroke="var(--gray-400)" />
            {ticks.map((tick) => {
                const x = xScale(tick);
                return (
                    <g key={tick} transform={`translate(${x} 0)`}>
                        <text
                            y={10}
                            dy="0.8em"
                            textAnchor="middle"
                            fill="green"
                            className="text-gray-400 text-2xs"
                        >
                            {formatter ? formatter(tick) : (tick)}
                        </text>
                        <line
                            y1={0}
                            y2={8}
                            stroke="var(--gray-300)"
                            data-testid="tickmark"
                        />
                        {/*
                    These are the vertial grid lines along the y-axis */}
                        {gridLineHeight ? (
                            <line
                                y1={0}
                                y2={-gridLineHeight}
                                stroke="var(--gray-200)"
                                strokeOpacity={0.8}
                                data-testid="gridline"
                            />
                        ) : null}
                    </g>
                )
            })}
        </g>
    )
}


export const YAxisTitle = ({ title }) => {
    return (
        <OutlinedSvgText
            stroke="#fff"
            strokeWidth={2.5}
            dx={-50}
            dy={210}
            transform={`rotate(270) translate(-130 -260)`}
            fill="var(--gray-600)"
            className="font-semibold text-2xs"
        >
            {title}
        </OutlinedSvgText>
    )
}

/** Y-axis with title and grid lines */

export const YAxis = ({ yScale, formatter, gridLineWidth }) => {

    const [yMin, yMax] = yScale.range();
    const ticks = yScale.ticks(numTicksForPixels(yMax - yMin, 50));

    return (
        <g data-testid="YAxis">
            <line x1={0} x2={0} y1={yMin} y2={yMax} stroke="var(--gray-400)" />
            {ticks.map((tick) => {
                const y = yScale(tick)
                return (
                    <g key={tick} transform={`translate(0 ${y})`}>
                        <text
                            dy="0.34em"
                            textAnchor="end"
                            dx={-12}
                            fill="green"
                            className="text-gray-400 text-2xs"
                        >
                            {tick}
                        </text>
                        <line
                            x1={0}
                            x2={-8}
                            stroke="var(--gray-300)"
                            data-testid="tickmark"
                        />
                        {/*
                    These are the vertial grid lines along the y-axis */}
                        {gridLineWidth ? (
                            <line
                                x1={0}
                                x2={gridLineWidth}
                                stroke="var(--gray-200)"
                                strokeOpacity={0.8}
                                data-testid="gridline"
                            />
                        ) : null}
                    </g>
                )
            })}
        </g>
    )
}

















































// import React from "react"
// import PropTypes from "prop-types"
// import * as d3 from 'd3'
// import { dimensionsPropsType } from "./utils";
// import { useChartDimensions } from "./Chart";

// const axisComponentsByDimension = {
//     x: AxisHorizontal,
//     y: AxisVertical,
// }
// const Axis = ({ dimension, ...props }) => {
//     const dimensions = useChartDimensions()
//     const Component = axisComponentsByDimension[dimension]
//     if (!Component) return null

//     return (
//         <Component
//             dimensions={dimension}
//             {...props}
//         />
//     )
// }

// Axis.propTypes = {
//     dimension: PropTypes.oneOf(["x", "y"]),
//     dimensions: dimensionsPropsType,
//     scale: PropTypes.func,
//     label: PropTypes.string,
//     formatTick: PropTypes.func,
// }

// Axis.defaultProps = {
//     dimension: "x",
//     scale: null,
//     formatTick: d3.format(","),
// }

// export default Axis


// function AxisHorizontal({ dimensions, label, formatTick, scale, ...props }) {
//     const numberOfTicks = dimensions.boundedWidth < 600
//         ? dimensions.boundedWidth / 100
//         : dimensions.boundedWidth / 250

//     const ticks = scale.ticks(numberOfTicks)

//     return (
//         <g className="Axis AxisHorizontal" transform={`translate(0, ${dimensions.boundedHeight})`} {...props}>
//             <line
//                 className="Axis__line"
//                 x2={dimensions.boundedWidth}
//             />

//             {ticks.map((tick, i) => (
//                 <text
//                     key={tick}
//                     className="Axis__tick"
//                     transform={`translate(${scale(tick)}, 25)`}
//                 >
//                     {formatTick(tick)}
//                 </text>
//             ))}

//             {label && (
//                 <text
//                     className="Axis__label"
//                     transform={`translate(${dimensions.boundedWidth / 2}, 60)`}
//                 >
//                     {label}
//                 </text>
//             )}
//         </g>
//     )
// }

// function AxisVertical({ dimensions, label, formatTick, scale, ...props }) {
//     const numberOfTicks = dimensions.boundedHeight / 70

//     const ticks = scale.ticks(numberOfTicks)

//     return (
//         <g className="Axis AxisVertical" {...props}>
//             <line
//                 className="Axis__line"
//                 y2={dimensions.boundedHeight}
//             />

//             {ticks.map((tick, i) => (
//                 <text
//                     key={tick}
//                     className="Axis__tick"
//                     transform={`translate(-16, ${scale(tick)})`}
//                 >
//                     {formatTick(tick)}
//                 </text>
//             ))}

//             {label && (
//                 <text
//                     className="Axis__label"
//                     style={{
//                         transform: `translate(-56px, ${dimensions.boundedHeight / 2}px) rotate(-90deg)`
//                     }}
//                 >
//                     {label}
//                 </text>
//             )}
//         </g>
//     )
// }
